import { Spinner } from "@love-cpmd/ui";
import { useEffect, useState } from "react";
import { LogoMark } from "./layout-bits";

/**
 * Shown while the app checks who is signed in. A free server sleeps when nobody uses it,
 * so after a few seconds the message explains the wait instead of looking stuck.
 */
export function FullPageLoader() {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setSlow(true), 4000);
    return () => window.clearTimeout(t);
  }, []);
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-background px-6 text-center">
      <LogoMark className="size-16 drop-shadow-[0_8px_18px_rgba(150,20,50,0.18)]" decorative />
      <div className="flex items-center gap-2.5 text-label-lg text-on-surface-variant">
        <Spinner className="text-primary" label="Loading LOVE CPMD" />
        Connecting to LOVE CPMD…
      </div>
      <p className={`max-w-xs text-body-sm text-on-surface-variant transition-opacity duration-500 ${slow ? "opacity-100" : "opacity-0"}`} aria-live="polite">
        {slow ? "The server is waking up after a quiet period. This can take up to a minute." : " "}
      </p>
    </div>
  );
}
